<template>
  <div class="content-container" v-bind:class="{'plansView':showTable, 'showsidebar':showsidebar==true, 'noscroll':showComparator===false&&question==3}">
    <b-container class="bv-example-row step active">
      <b-row class="welcomerow" v-bind:class="{ active: question == 0 }">
        <b-col sm="12" md="6">
          <div class="welcometext">
            <h1 class="types__heading">
              Bienvenido al configurador <br class="visible-lg">de membresías de <b>Fundación HTN</b>.
            </h1>
            <p>
              Te invitamos a dejar tu huella en el sector social, junto a nuestra fundación. Creemos que a través de la tecnología podemos potenciar la acción social y generar un gran cambio de conciencia.
            </p>
            <p>
              Con una pequeña cuota de nuestro tiempo, con la misma responsabilidad e inteligencia que trabajamos día a día, pero esta vez, en beneficio del sector social, seremos capaces de demostrar y demostrarnos, que juntos y en familia, podemos hacer un mundo mejor.
            </p>
            <p class="m-b-30">
              A través de este configurador podrás seleccionar la categoría y el plan de la membresía que mejor se adapte a las necesidades de la empresa. 
            </p>
            <b-button variant="loginInput" @click="nextQuestion">Comencemos</b-button>
          </div>
        </b-col>
        <b-col sm="12" md="6" class="welcomeimage"> </b-col>
      </b-row>
      <b-row class="welcomerow steps-wrapper q2" v-bind:class="{ active: question > 0 && question < 3 }">
        <div class="d-flex">
          <div class="main-area">
            <div class="top-block">
              <a class="go-back" name="goback" @click="backQuestion">
                <i class="fas fa-angle-left"></i>
                <span>atrás</span>
              </a>
              <div>
                <div class="steps-selector" dropdown="">
                  <button
                    aria-controls="step-selector-list"
                    class="selector-toggle mat-ripple"
                    dropdowntoggle=""
                    id="step-selector-toggle"
                    mat-ripple=""
                    name="A button"
                    aria-haspopup="true"
                  >
                    <span class="active-step">Paso {{question}} </span>
                    <span>de 3</span>
                  </button>
                  <button
                    aria-controls="step-selector-list"
                    class="selector-toggle mat-ripple sidebarshow"
                    aria-haspopup="true"
                    @click="showsidebar=true"
                  >
                    <span class="active-step"><i class="fas fa-arrow-left"></i></span>
                  </button>
                  <!---->
                </div>
              </div>
            </div>
            <div class="question" v-bind:class="{ active: question == 1 }">
              <div class="platforms" svg-icons="">
                <h2 class="heading">
                  ¿Cuántos empleados trabajan en tu compañía?
                </h2>
                <div class="designs-holder">
                  <!---->
                  <div class="input-group">
                  <label>Ingresa la cantidad de empleados</label>
                  <div
                    class="option "
                  >
                    <b-form-input
                      type="text"
                      class="texts-holder employeesback"
                      v-bind:class="{error:errorEmployees==true}"
                      @change="setEmployees($event)"
                      v-number-only
                      maxlength='7'
                      v-model="employees"
                      placeholder=""
                    ></b-form-input>
                    </div>
                    <label v-if="errorEmployees==true">Por favor indica la cantidad de empleados.</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="question" v-bind:class="{ active: question == 2}">
              <div class="platforms" svg-icons="">
                <h2 class="heading m-bot-30">
                  ¿Qué cantidad de empleados consideras que participaran <br class="visible-lg">en actividades solidarias?
                </h2>
                <b-form-group label="¿Cómo deseas indicar la cantidad?" class=" m-bot-50">
                  <b-form-radio-group id="" v-model="howmany" name="modalidad"  class="w280px">
                    <b-form-radio value="percent">Seleccionar porcentaje</b-form-radio>
                    <b-form-radio value="manual">Introducir cantidad de empleados</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
                <div class="designs-holder" v-if="howmany=='percent'">
                  <!---->
                  <div class="input-group w-100">
                     <b-col sm='12' class="percentsection">
                      <input class="variation" id="p10" type="radio" value="10" name="color">
                      <label for="p10" class="tag" @click="messageError ='';activeEmployees=10;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==10 && activeEmployeesNumber>0}">10%</label>
                      <input class="variation" id="p20" type="radio" value="20" name="color">
                      <label for="p20" class="tag" @click="messageError ='';activeEmployees=20;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==20 && activeEmployeesNumber>0}">20%</label>
                      <input class="variation" id="p30" type="radio" value="30" name="color">
                      <label for="p30" class="tag" @click="messageError ='';activeEmployees=30;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==30 && activeEmployeesNumber>0}">30%</label>
                      <input class="variation" id="p40" type="radio" value="40" name="color">
                      <label for="p40" class="tag" @click="messageError ='';activeEmployees=40;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==40 && activeEmployeesNumber>0}">40%</label>
                      <input class="variation" id="p50" type="radio" value="50" name="color">
                      <label for="p50" class="tag" @click="messageError ='';activeEmployees=50;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==50 && activeEmployeesNumber>0}">50%</label>
                      <input class="variation" id="p60" type="radio" value="60" name="color">
                      <label for="p60" class="tag" @click="messageError ='';activeEmployees=60;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==60 && activeEmployeesNumber>0}">60%</label>
                      <input class="variation" id="p70" type="radio" value="30" name="color">
                      <label for="p70" class="tag" @click="messageError ='';activeEmployees=70;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==70 && activeEmployeesNumber>0}">70%</label>
                      <input class="variation" id="p80" type="radio" value="80" name="color">
                      <label for="p80" class="tag" @click="messageError ='';activeEmployees=80;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==80 && activeEmployeesNumber>0}">80%</label>
                      <input class="variation" id="p90" type="radio" value="90" name="color">
                      <label for="p90" class="tag" @click="messageError ='';activeEmployees=90;percentCustomNumber='';activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==90 && activeEmployeesNumber>0}">90%</label>
                      <input class="variation" id="p100" type="radio" value="100" name="color">
                      <label for="p100" class="tag" @click="messageError ='';percentCustomNumber='';activeEmployees=100;activeEmployeesNumber=Math.floor(activeEmployees*employees/100);activeEmployeesNumberPivot=activeEmployeesNumber;customPercent=false" v-bind:class="{activeInput : activeEmployees==100 && activeEmployeesNumber>0}">100%</label>
                      <input class="variation" id="other" type="radio" value="100" name="color">
                      <label for="other" class="tag" @click="messageError ='';customPercent=true">Otro</label>
                      <div class="option tag" v-if="customPercent==true">
                        <input
                          type="text"
                          class="texts-holder percent holderpercent"
                          v-number-only
                          v-model="percentCustomNumber"
                          v-bind:class="{invalid:activeEmployeesNumber < 1 || activeEmployeesNumber > 100}"
                          maxlength="3"
                        >
                        </div>
                      </b-col>
                  </div>
                  </div>
                  <div class="designs-holder" v-if="howmany=='manual'">
                  <div class="input-group w-100">
                     <b-col sm='12'>
                      <label style="display:none">Indica la cantidad de empleados que participarán en actividades solidarias con <b>Fundación HTN</b></label>
                      <div class="option customInputOption">
                        <b-form-input
                          type="text"
                          class="texts-holder employeesback"
                          maxlength='7'
                          @input="messageError ='';activeEmployeesInput($event)"
                          v-number-only
                          v-model.number="activeEmployeesNumberPivot"
                        ></b-form-input>
                        <label class="error" v-if="errorActiveEmployees">
                          Puedes indicar hasta un máximo de {{employees}} empleados
                        </label>
                        </div>
                     </b-col>
                  </div>
                </div>
              </div>
            </div>
              <div class="errorLabel">
                {{messageError}}
              </div>
                <b-button variant="loginInput" class="continue" continue-button="" name="next" @click="nextQuestion">
                    Continuar
                </b-button>
          </div>
          <div class="sidebar">
            <div class="sidebar__handle" v-if="showsidebar==true">
              <div class="sidebar__handle__icon" @click="showsidebar=false">
                <i class="fas fa-times"></i>
              </div>
            </div>
            <div class="hours-report-block">
              <div>
                <div class="hours-report">
                  <div class="sidebar-title">
                    <h2 class="heading">Tu configuración</h2>
                  </div>
                  <div class="time-section time-total">
                    <div class="description">
                      Cantidad de empleados:
                    </div>
                    <div class="time">
                      <div class="average">
                        <div>
                          <div class="odometer-like">
                            <span class="spin-entry transition in-viewport">
                              {{ employees }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="time-section time-total" v-bind:class="{disabled: question<2}">
                    <div class="description">
                      Empleados participantes:
                    </div>
                    <div class="time">
                      <div class="average">
                        <div>
                          <div class="odometer-like activeEmployees">
                            <span
                              class="spin-entry transition in-viewport"
                                v-if="question==2"> 
                              <small><b>{{ Number(activeEmployees).toFixed(2) }}%</b></small><br>
                              {{ Math.floor(activeEmployeesNumber) }}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="hints-block">
            </div>
          </div>
        </div>
      </b-row>
    </b-container>

      <b-row class="welcomerow steps-wrapper m-l-0 q3" v-bind:class="{ active: question == 3 }">
        <div class="steps-wrapper no-spaces">
          <div class="main-area full-width">
            <div class="top-block">
                <a class="go-back" name="goback" @click="backQuestion">
                  <i class="fas fa-angle-left"></i>
                  <span>atrás</span>
                </a>
                <div>
                <div class="steps-selector">
                  <button
                    aria-controls="step-selector-list"
                    class="selector-toggle mat-ripple"
                    id="step-selector-toggle"
                    mat-ripple=""
                    name="A button"
                    aria-haspopup="true"
                  >
                    <span class="active-step">Paso {{question}} </span>
                    <span>de 3</span>
                  </button>
                  
                </div>
              </div>
            </div>
            <div class="question" v-bind:class="{ active: question == 3 }">
              <div class="platforms plansstep">
                <h2 class="heading tabletitle">
                  <small class="subtitle">Has seleccionado que <b>{{activeEmployeesNumber}}</b> empleados de tu compañía participan en actividades solidarias.</small>
                 ¡Perteneces a la categoría <b>{{ category.name }}</b>! <small class="x2">({{category.minWorkers}} a {{category.maxWorkers}} empleados participantes)</small>
                 <small class="subtitle" v-if="showComparator==false">Ahora selecciona el plan que más se adapte a tu compañía</small>
                </h2>
                <div class="designs-holder pricestable noscroll" v-if="showComparator==false">
                    <div class="ditem" v-for="(p,index) in plans" :key="index">
                      <div class="dtitle">{{p.name}}</div>
                      <div class="ditemcontainer">
                        <p><small>Inversión mensual</small></p>
                        <h2>${{formatNumber(p.mensual)}}</h2>
                        <p><small>Valor mensual por empleado: <b>${{formatPrice(Number(p.mensual)/Number(activeEmployeesNumber))}}</b></small></p>
                        <p style="margin-top:20px;font-size:60%;line-height:14px">Los precios mostrados son en Dólares Americanos (USD).</p>
                      </div>
                      <div class="ditemfooter">
                        <button class="btn btn-sm btn-loginInput" @click="selectPlan(p.id)">Seleccionar</button>
                      </div>
                    </div>
                </div>
                <div class="changeplansview" v-if="showComparator==false">
                    <div class="showButton">
                      <p class="btn" @click="showComparator=true">Mostrar comparador de planes</p>
                    </div>
                </div>
                <div v-if="showComparator==true">
                <b-form-group label="Selecciona una modalidad del plan:">
                  <div class="radiogroup">
                  <div class="custom-control custom-control-inline custom-radio" id="radio-group-modalidad">
                    <input class="custom-control-input" type="radio" @click="price=1" name="modalidad" value=1 id="price1" :class="{selected:price==1}"><label class="custom-control-label" for="price1">Mensual</label>
                  </div>
                  <div class="custom-control custom-control-inline custom-radio" id="radio-group-modalidad">  
                    <input class="custom-control-input" type="radio" @click="price=12" name="modalidad" value=12 id="price12" :class="{selected:price==12}"><label class="custom-control-label" for="price12"> Anual</label>
                  </div></div>
                  <br>
                  <small class="disclaimer"></small>
                </b-form-group>
                  <div class="menu-indicator" v-if="{ active: question == 3 }">
                    <div class="indicator-wrapper">
                      <div class="box-wrapper">
                        <div class="box-outer">
                          <div class="box"></div>
                          <div class="box"></div>
                          <div class="box"></div>
                          <div class="box"></div>
                        </div>
                      </div>

                      <div class="indicator-cursor">
                      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47.619 68.23"><title>noun_692985</title><path d="M59.773,79.1l0.033-.176c2.062-9.136,9.688-20.832,8.023-31.685-0.45-2.583-.877-3.861-1.383-4.527-0.33-.435-0.807-0.769-2.285-0.769a4.6,4.6,0,0,0-1.063.116L63.041,47.7a1.875,1.875,0,0,1-3.749-.035l0.061-6.554c0.071-2.036-.252-2.656-0.443-2.862-0.169-.181-0.651-0.485-2.388-0.485a2.962,2.962,0,0,0-2.436.915l-0.07,5.843a1.875,1.875,0,1,1-3.749-.035l0.062-6.553c0.071-2.036-.252-2.657-0.443-2.864-0.169-.181-0.653-0.485-2.389-0.485a3.423,3.423,0,0,0-2.054.551l-0.177.17-0.025,9.4a1.875,1.875,0,0,1-3.749-.011L41.554,21.73c0.071-2.042-.25-2.66-0.443-2.869-0.169-.181-0.652-0.485-2.389-0.485a3.225,3.225,0,0,0-2.223.688,2.533,2.533,0,0,0-.654,2.17l0,0.116V54.614a1.875,1.875,0,0,1-3.75,0V47.837l-0.875.232a4.476,4.476,0,0,0-3.115,3.319A10.042,10.042,0,0,0,29.864,58.8c3.487,5.315,8.108,11.265,9.58,18.686l0.251,1.521Z" transform="translate(-24.187 -14.626)" style="fill:#fff"/><path d="M61.32,82.856l-23.33-.1a1.875,1.875,0,0,1-1.863-1.759c-0.476-7.733-5.126-13.62-9.4-20.132-2.013-3.068-3.083-6.96-2.266-10.351,0.766-3.185,3.113-5.585,7-6.378l0.64-.087V21.35l-0.011-.659a6.017,6.017,0,0,1,1.865-4.38,6.923,6.923,0,0,1,4.769-1.685c1.871,0,3.817.263,5.136,1.683,1.293,1.391,1.519,3.4,1.445,5.492l-0.026,9.37,0.724-.2a8.546,8.546,0,0,1,1.5-.129,10.564,10.564,0,0,1,2.776.309,4.92,4.92,0,0,1,2.36,1.374,4.7,4.7,0,0,1,.782,1.153L53.7,34.519l1.325-.374a8.535,8.535,0,0,1,1.495-.129,10.564,10.564,0,0,1,2.776.309A4.922,4.922,0,0,1,61.657,35.7a5.227,5.227,0,0,1,1.235,2.486l0.015,0.11,0.288-.049a8.892,8.892,0,0,1,.966-0.052,6.109,6.109,0,0,1,5.272,2.251c1.127,1.485,1.653,3.64,2.1,6.188,1.965,12.813-7.146,26.223-8.345,34.614A1.875,1.875,0,0,1,61.32,82.856ZM59.773,79.1l0.033-.176c2.062-9.136,9.688-20.832,8.023-31.685-0.45-2.583-.877-3.861-1.383-4.527-0.33-.435-0.807-0.769-2.285-0.769a4.6,4.6,0,0,0-1.063.116L63.041,47.7a1.875,1.875,0,0,1-3.749-.035l0.061-6.554c0.071-2.036-.252-2.656-0.443-2.862-0.169-.181-0.651-0.485-2.388-0.485a2.962,2.962,0,0,0-2.436.915l-0.07,5.843a1.875,1.875,0,1,1-3.749-.035l0.062-6.553c0.071-2.036-.252-2.657-0.443-2.864-0.169-.181-0.653-0.485-2.389-0.485a3.423,3.423,0,0,0-2.054.551l-0.177.17-0.025,9.4a1.875,1.875,0,0,1-3.749-.011L41.554,21.73c0.071-2.042-.25-2.66-0.443-2.869-0.169-.181-0.652-0.485-2.389-0.485a3.225,3.225,0,0,0-2.223.688,2.533,2.533,0,0,0-.654,2.17l0,0.116V54.614a1.875,1.875,0,0,1-3.75,0V47.837l-0.875.232a4.476,4.476,0,0,0-3.115,3.319A10.042,10.042,0,0,0,29.864,58.8c3.487,5.315,8.108,11.265,9.58,18.686l0.251,1.521Z" transform="translate(-24.187 -14.626)"/></svg>
                      </div>
                    </div>
                  </div>
                <div class="designs-holder">
                  <table v-if="category!=false">
                  <tr>
                    <th></th>
                      <th v-for="(pi, index) in plans" :key="index">
                        {{pi.name}}
                      </th>
                  </tr>
                  <tr v-if="price==1">
                    <td><b>Inversión mensual total</b> <br>Los precios mostrados son en Dólares Americanos (USD).</td>
                      <th v-for="(p,index) in plans" :key="index">
                        ${{formatPrice(p.mensual)}}
                      </th>
                    </tr>
                  <tr v-if="price==12">
                    <td><b>Inversión anual</b> <br>Los precios mostrados son en Dólares Americanos (USD).</td>
                      <th v-for="(p,index) in plans" :key="index">
                        ${{formatPrice(Number(p.mensual*price).toFixed(2))}}
                      </th>
                    </tr>

                  <tr v-if="price==1">
                    <td>Inversión mensual por empleado ({{activeEmployeesNumber}} participantes)</td>
                      <th v-for="(p,index) in plans" :key="index">
                        <small>${{formatPrice(Number(p.mensual)/Number(activeEmployeesNumber))}}</small>
                      </th>
                    </tr>
                  <tr v-if="price==12">
                    <td>Inversión anual por empleado ({{activeEmployeesNumber}} participantes)</td>
                      <th v-for="(p,index) in plans" :key="index">
                        <small>${{(p.mensual*price/activeEmployeesNumber).toFixed(2)}}</small>
                      </th>
                    </tr>
                  <tr v-for="(item,a) in benefits" :key="a">
                      <td v-html="item.text"></td>
                      <td v-for="(ra,i) in item.row" :key="i">
                        <i v-if="ra == 'true'" class="fas fa-check"></i>
                        <i v-if="ra == 'false'" class="fas fa-times"></i>
                        <p class="custonDetail" v-if=" ra != 'true' && ra != 'false'" v-html="ra">
                          </p>
                      </td>
                  </tr>

                  <tr>
                      <td></td>
                      <td v-for="(p,i) in plans" :key="i">
                        <button class="btn btn-sm btn-loginInput" @click="selectPlan(p.id)">Seleccionar</button>
                      </td>
                  </tr>
                  </table>
                </div>
              </div>
                <div class="changeplansview" v-if="showComparator==true">
                    <div class="showButton">
                      <p class="btn" @click="showComparator=false">Volver</p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>
      <b-row class="welcomerow steps-wrapper m-l-0 q4" v-bind:class="{ active: question == 4 }">
        <div class="steps-wrapper no-spaces">
          <div class="main-area full-width">
            <div class="top-block">
              <a class="go-back" name="goback" @click="backQuestion">
                <i class="fas fa-angle-left"></i>
                <span>atrás</span>
              </a>
            </div>
            <div class="question" v-bind:class="{ active: question == 4 }">
              <div class="platforms reportPlan">
                <div class="designs-holder">
                <b-row>
                  <b-col sm="12" md="9">
                  <div class="titleContainer">
                    <img :src="'/assets/img/icons/category-'+empresa.category_id+'.svg'">
                    <div class="contentTitle">
                      <small>Categoría:</small>
                      <h2 class="heading">
                        {{ selectedcategory.name }}
                      </h2>
                    </div>
                  </div>
                  </b-col>
                  <b-col sm="12" md="3">
                    <div class="itemBenefits beneficio get" @click="solicitud" :class="{loading:solicitudflag===true}">
                      <div class="itemcontainerb">
                      <label class="itemTitle">Solicitar</label>
                      <label class="itemValue">Membresía</label>
                      </div>
                      <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <svg class="iconB" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.26 58.26"><path class="cls-blanco" d="M46.7,35.5a3.44,3.44,0,0,0-.84-1l-.44-.35.39-.39a3.46,3.46,0,0,0,0-4.88l-.28-.25-.44-.34.39-.4A3.46,3.46,0,0,0,46,23.76a3.55,3.55,0,0,0-2-1.6L43.61,22l.09-.44a3.38,3.38,0,0,0-.38-2.45,3.45,3.45,0,0,0-4.7-1.26l-9.85,5.68V22.7c0-1.58-1.71-5.46-2.63-7a5,5,0,0,0-6.82-1.82l-.94.54a.81.81,0,0,0-.29,1.11c1.58,2.74,3.33,8.19,2.5,11.3l0,.11A15.21,15.21,0,0,1,18,31.81l-.45.59L17,31.32a.81.81,0,0,0-.7-.41.77.77,0,0,0-.41.11L9,35a.83.83,0,0,0-.3,1.12L19.27,54.37a.83.83,0,0,0,1.12.3l6.83-3.94a.83.83,0,0,0,.3-1.12l-.77-1.33.72-.11a29.76,29.76,0,0,0,10.28-3.53l7.69-4.43A3.45,3.45,0,0,0,46.7,35.5ZM20.28,52.85,10.53,36,16,32.83,25.7,49.72ZM45.47,37.69a1.84,1.84,0,0,1-.78,1.07l-.06,0h0l-7.69,4.45a28.33,28.33,0,0,1-9.68,3.31l-1.34.28L18.52,34l.83-1.25a16.29,16.29,0,0,0,2.8-5.58c.81-3-.73-8.47-2.08-11.4l-.2-.44.44-.22a3.37,3.37,0,0,1,4.41,1.33c1.05,1.81,2.7,6.32,2.13,8.47a.82.82,0,0,0,.57,1,.84.84,0,0,0,.62-.09l11.39-6.57a1.81,1.81,0,0,1,1.82,3.14l-6.84,3.95a.81.81,0,0,0-.38.49.81.81,0,0,0,.58,1,.79.79,0,0,0,.62-.08l6.83-4a1.91,1.91,0,0,1,2.52.74,1.8,1.8,0,0,1-.66,2.48h0L37.09,31a.81.81,0,0,0-.3,1.11.78.78,0,0,0,.49.38.79.79,0,0,0,.62-.08l4.56-2.63a1.77,1.77,0,0,1,1.37-.18,1.81,1.81,0,0,1,.51,3.28l-.11.07-4.51,2.6A.82.82,0,0,0,40.53,37l2.28-1.32a1.81,1.81,0,0,1,2.66,2Z"/><path class="cls-blanco" d="M14.56,11.85a.82.82,0,0,0,.61.11.85.85,0,0,0,.51-.36.8.8,0,0,0-.22-1.1h0L13,8.88a.82.82,0,0,0-.5-.17h-.13a.81.81,0,0,0-.68.93.81.81,0,0,0,.33.53Z"/><path class="cls-blanco" d="M21.91,8a.8.8,0,0,0,.75-.85l-.18-2.93a.81.81,0,0,0-1.42-.48.79.79,0,0,0-.2.59L21,7.28A.82.82,0,0,0,21.91,8Z"/><path class="cls-blanco" d="M28.3,10.52,30.58,9.2A.79.79,0,0,0,31,8.71a.84.84,0,0,0-.09-.62.81.81,0,0,0-1.11-.3L27.49,9.11a.78.78,0,0,0-.38.49.79.79,0,0,0,.08.62A.82.82,0,0,0,28.3,10.52Z"/><path class="cls-blanco" d="M11.74,19.81a.86.86,0,0,0,.61-.08l2.28-1.32a.82.82,0,0,0,.3-1.11.81.81,0,0,0-1.11-.3l-2.28,1.31a.83.83,0,0,0-.38.5.79.79,0,0,0,.08.62A.83.83,0,0,0,11.74,19.81Z"/></svg>
                    </div>
                  </b-col>
                </b-row>
                </div>
                <div class="designs-holder planPresentation" >
                  <b-row>
                    <b-col sm="6" md="3" >
                      <div class="itemBenefits">
                      <div class="itemcontainerb">
                        <label class="itemTitle">Empleados:</label>
                        <label class="itemValue">{{formatNumber(employees)}}</label>
                      </div>
                        <img src="/assets/img/icons/employees.svg">
                      </div>
                    </b-col>
                    <b-col sm="6" md="3" >
                      <div class="itemBenefits">
                      <div class="itemcontainerb">
                        <label class="itemTitle">Empleados solidarios:</label>
                        <label class="itemValue">{{ formatNumber(Math.floor(activeEmployees*employees/100)) }}</label>
                      </div>
                        <img src="/assets/img/icons/volunteers.svg">
                      </div>
                    </b-col>
                    <b-col sm="12" md="3" >
                      <div class="itemBenefits">
                      <div class="itemcontainerb">
                        <label class="itemTitle">Plan: {{selectedPlan.name}}</label>
                        <label class="itemValue" >${{(Math.floor(activeEmployees*employees/100)>2500) ? formatPrice(selectedPlan.mensual*Math.floor(activeEmployees*employees/100)/2500) : formatPrice(selectedPlan.mensual*price)}} <small>El <span v-if="price==1">mes</span> <span v-if="price==12">año</span></small></label>
                      </div><img src="/assets/img/icons/price.svg">
                      </div>
                    </b-col>
                    <b-col sm="12" md="3" >
                      <div class="itemBenefits beneficio download" @click="getFile" :class="{loading:getpdfflag===true}">
                      <div class="itemcontainerb">
                        <label class="itemTitle">Descargar</label>
                        <label class="itemValue">Membresía</label>
                      </div>
                        <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <svg class="iconB" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.26 58.26">
                            <g id="downloading-file"><path id="Path_174" data-name="Path 174" class="cls-blanco" d="M40.77,34.85a2,2,0,0,0-2,2h0V40h-19V36.84a2,2,0,0,0-4,0v5.1a2,2,0,0,0,2,2h23a2,2,0,0,0,2-2h0v-5.1a2,2,0,0,0-2-2Z"/><path class="cls-tema" d="M40.77,44.44h-23a2.5,2.5,0,0,1-2.49-2.5v-5.1a2.5,2.5,0,0,1,5,0v2.61h18V36.84a2.49,2.49,0,1,1,5,0v5.1A2.5,2.5,0,0,1,40.77,44.44Zm-23-9.09a1.49,1.49,0,0,0-1.49,1.49v5.1a1.5,1.5,0,0,0,1.49,1.5h23a1.5,1.5,0,0,0,1.49-1.5v-5.1a1.49,1.49,0,1,0-3,0v3.61h-20V36.84A1.5,1.5,0,0,0,17.78,35.35Z"/><path id="Path_175" data-name="Path 175" class="cls-blanco" d="M28.67,37a.85.85,0,0,0,1.2,0l7-7a.72.72,0,0,0,0-1,.7.7,0,0,0-.5-.21H33.08V15.88a1.56,1.56,0,0,0-1.56-1.55H27a1.54,1.54,0,0,0-1.55,1.55h0V28.77H22.19a.71.71,0,0,0-.71.71.67.67,0,0,0,.21.5Z"/><path class="cls-tema" d="M29.27,37.71a1.35,1.35,0,0,1-.95-.39l-7-7a1.23,1.23,0,0,1-.35-.85,1.21,1.21,0,0,1,1.2-1.22H25V15.88A2.05,2.05,0,0,1,27,13.83h4.5a2,2,0,0,1,1.46.6,2.09,2.09,0,0,1,.6,1.45V28.27h2.78a1.19,1.19,0,0,1,.85.35,1.24,1.24,0,0,1,.36.86,1.22,1.22,0,0,1-.36.86l-7,7A1.37,1.37,0,0,1,29.27,37.71ZM29,36.61a.35.35,0,0,0,.5,0l7-7a.24.24,0,0,0,0-.3.2.2,0,0,0-.15-.06H32.58V15.88a1,1,0,0,0-.31-.74,1.06,1.06,0,0,0-.75-.31H27A1,1,0,0,0,26,15.88V29.27H22.19a.21.21,0,0,0-.15.36Z"/></g>
                        </svg>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row v-if="listBenefitsCommunities.length>0">
                      <b-col sm='12'>
                        <div class="itemBenefits list m-t-30">
                          <label class="benefitsTitle">				
                            Beneficios por pertenecer a la categoría <b>{{ selectedcategory.name }}</b>
                          </label>
                          <div v-for="it in listBenefitsCommunities" :key="it" class="itemb">
                            <div class="iconben">
                              <img  :src="'/assets/img/icons/'+it.icon">
                            </div>
                          <div class="container-benefit">
                            <div class="benefitsitem">
                              <h5 v-html="it.title"></h5>
                              <p v-html="it.text"></p>
                             </div>
                          </div>
                        </div>
                        </div>
                      </b-col>
                  </b-row>
                  <b-row v-if="listBenefits.length>0">
                      <b-col sm='12'>
                        <div class="itemBenefits planlist list m-t-30">
                          <label class="benefitsTitle">
                            Beneficios del plan <b>{{selectedPlan.name}}</b>			
                          </label>
                          <div v-for="it in listBenefits" :key="it" class="itemb">
                            <div class="iconben">
                              <img  :src="'/assets/img/icons/'+it.icon">
                            </div>
                            <div class="container-benefit">                           
                            <div class="benefitsitem">
                              <h5 v-html="it.title"></h5>
                              <p   v-html="(it.value!='true' && it.value!='false') ? it.text+' ('+it.value+')':it.text">
                              <span v-if="it.value!='true' && it.value!='false'">({{it.value}})</span></p>
                             </div>
                          </div>
                          </div>
                        </div>
                        </b-col>
                  </b-row>
                  <b-row class="bottomOptions">
                    <b-col md="6">
                    </b-col>
                    <b-col md="3">
                      <div class="itemBenefits beneficio download" @click="getFile" :class="{loading:getpdfflag===true}"><div class="itemcontainerb">
                        <label class="itemTitle">Descargar</label>
                        <label class="itemValue">Membresía</label></div>
                        <svg class="iconB" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.26 58.26">
                            <g id="downloading-file"><path id="Path_174" data-name="Path 174" class="cls-blanco" d="M40.77,34.85a2,2,0,0,0-2,2h0V40h-19V36.84a2,2,0,0,0-4,0v5.1a2,2,0,0,0,2,2h23a2,2,0,0,0,2-2h0v-5.1a2,2,0,0,0-2-2Z"/><path class="cls-tema" d="M40.77,44.44h-23a2.5,2.5,0,0,1-2.49-2.5v-5.1a2.5,2.5,0,0,1,5,0v2.61h18V36.84a2.49,2.49,0,1,1,5,0v5.1A2.5,2.5,0,0,1,40.77,44.44Zm-23-9.09a1.49,1.49,0,0,0-1.49,1.49v5.1a1.5,1.5,0,0,0,1.49,1.5h23a1.5,1.5,0,0,0,1.49-1.5v-5.1a1.49,1.49,0,1,0-3,0v3.61h-20V36.84A1.5,1.5,0,0,0,17.78,35.35Z"/><path id="Path_175" data-name="Path 175" class="cls-blanco" d="M28.67,37a.85.85,0,0,0,1.2,0l7-7a.72.72,0,0,0,0-1,.7.7,0,0,0-.5-.21H33.08V15.88a1.56,1.56,0,0,0-1.56-1.55H27a1.54,1.54,0,0,0-1.55,1.55h0V28.77H22.19a.71.71,0,0,0-.71.71.67.67,0,0,0,.21.5Z"/><path class="cls-tema" d="M29.27,37.71a1.35,1.35,0,0,1-.95-.39l-7-7a1.23,1.23,0,0,1-.35-.85,1.21,1.21,0,0,1,1.2-1.22H25V15.88A2.05,2.05,0,0,1,27,13.83h4.5a2,2,0,0,1,1.46.6,2.09,2.09,0,0,1,.6,1.45V28.27h2.78a1.19,1.19,0,0,1,.85.35,1.24,1.24,0,0,1,.36.86,1.22,1.22,0,0,1-.36.86l-7,7A1.37,1.37,0,0,1,29.27,37.71ZM29,36.61a.35.35,0,0,0,.5,0l7-7a.24.24,0,0,0,0-.3.2.2,0,0,0-.15-.06H32.58V15.88a1,1,0,0,0-.31-.74,1.06,1.06,0,0,0-.75-.31H27A1,1,0,0,0,26,15.88V29.27H22.19a.21.21,0,0,0-.15.36Z"/></g>
                        </svg>
                        <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                      </div>
                    </b-col>
                    <b-col md="3">
                      <div class="itemBenefits beneficio get" @click="solicitud" :class="{loading:solicitudflag===true}">
                        <div class="itemcontainerb">
                        <label class="itemTitle">Solicitar</label>
                        <label class="itemValue">Membresía</label>
                        </div>
                        <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
                        <svg class="iconB" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.26 58.26"><path class="cls-blanco" d="M46.7,35.5a3.44,3.44,0,0,0-.84-1l-.44-.35.39-.39a3.46,3.46,0,0,0,0-4.88l-.28-.25-.44-.34.39-.4A3.46,3.46,0,0,0,46,23.76a3.55,3.55,0,0,0-2-1.6L43.61,22l.09-.44a3.38,3.38,0,0,0-.38-2.45,3.45,3.45,0,0,0-4.7-1.26l-9.85,5.68V22.7c0-1.58-1.71-5.46-2.63-7a5,5,0,0,0-6.82-1.82l-.94.54a.81.81,0,0,0-.29,1.11c1.58,2.74,3.33,8.19,2.5,11.3l0,.11A15.21,15.21,0,0,1,18,31.81l-.45.59L17,31.32a.81.81,0,0,0-.7-.41.77.77,0,0,0-.41.11L9,35a.83.83,0,0,0-.3,1.12L19.27,54.37a.83.83,0,0,0,1.12.3l6.83-3.94a.83.83,0,0,0,.3-1.12l-.77-1.33.72-.11a29.76,29.76,0,0,0,10.28-3.53l7.69-4.43A3.45,3.45,0,0,0,46.7,35.5ZM20.28,52.85,10.53,36,16,32.83,25.7,49.72ZM45.47,37.69a1.84,1.84,0,0,1-.78,1.07l-.06,0h0l-7.69,4.45a28.33,28.33,0,0,1-9.68,3.31l-1.34.28L18.52,34l.83-1.25a16.29,16.29,0,0,0,2.8-5.58c.81-3-.73-8.47-2.08-11.4l-.2-.44.44-.22a3.37,3.37,0,0,1,4.41,1.33c1.05,1.81,2.7,6.32,2.13,8.47a.82.82,0,0,0,.57,1,.84.84,0,0,0,.62-.09l11.39-6.57a1.81,1.81,0,0,1,1.82,3.14l-6.84,3.95a.81.81,0,0,0-.38.49.81.81,0,0,0,.58,1,.79.79,0,0,0,.62-.08l6.83-4a1.91,1.91,0,0,1,2.52.74,1.8,1.8,0,0,1-.66,2.48h0L37.09,31a.81.81,0,0,0-.3,1.11.78.78,0,0,0,.49.38.79.79,0,0,0,.62-.08l4.56-2.63a1.77,1.77,0,0,1,1.37-.18,1.81,1.81,0,0,1,.51,3.28l-.11.07-4.51,2.6A.82.82,0,0,0,40.53,37l2.28-1.32a1.81,1.81,0,0,1,2.66,2Z"/><path class="cls-blanco" d="M14.56,11.85a.82.82,0,0,0,.61.11.85.85,0,0,0,.51-.36.8.8,0,0,0-.22-1.1h0L13,8.88a.82.82,0,0,0-.5-.17h-.13a.81.81,0,0,0-.68.93.81.81,0,0,0,.33.53Z"/><path class="cls-blanco" d="M21.91,8a.8.8,0,0,0,.75-.85l-.18-2.93a.81.81,0,0,0-1.42-.48.79.79,0,0,0-.2.59L21,7.28A.82.82,0,0,0,21.91,8Z"/><path class="cls-blanco" d="M28.3,10.52,30.58,9.2A.79.79,0,0,0,31,8.71a.84.84,0,0,0-.09-.62.81.81,0,0,0-1.11-.3L27.49,9.11a.78.78,0,0,0-.38.49.79.79,0,0,0,.08.62A.82.82,0,0,0,28.3,10.52Z"/><path class="cls-blanco" d="M11.74,19.81a.86.86,0,0,0,.61-.08l2.28-1.32a.82.82,0,0,0,.3-1.11.81.81,0,0,0-1.11-.3l-2.28,1.31a.83.83,0,0,0-.38.5.79.79,0,0,0,.08.62A.83.83,0,0,0,11.74,19.81Z"/></svg>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-row>

      <b-row class="welcomerow steps-wrapper m-l-0 loading" v-bind:class="{ 'active': loading == true}">
        <div class="loader-wrapper">
            <div class="loadingio-spinner-bars-7v957tsw7m"><div class="ldio-g24663uogbv">
              <div></div><div></div><div></div><div></div>
            </div></div>
        </div>
      </b-row>

      <b-row class="welcomerow steps-wrapper m-l-0 loading " v-bind:class="{ active: customForm == true, animate:animateCustom==true }">
        <div class="steps-wrapper">
          <div class="main-area full-width">
        <div class="top-block">
          <a class="go-back" name="goback" @click="backQuestion">
            <i class="fas fa-angle-left"></i>
            <span>atrás</span>
          </a>
        </div>
        <div class="loader-wrapper thakyoumessage customForm">
          <svg class="iconB" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.26 58.26"><path class="cls-blanco" d="M46.7,35.5a3.44,3.44,0,0,0-.84-1l-.44-.35.39-.39a3.46,3.46,0,0,0,0-4.88l-.28-.25-.44-.34.39-.4A3.46,3.46,0,0,0,46,23.76a3.55,3.55,0,0,0-2-1.6L43.61,22l.09-.44a3.38,3.38,0,0,0-.38-2.45,3.45,3.45,0,0,0-4.7-1.26l-9.85,5.68V22.7c0-1.58-1.71-5.46-2.63-7a5,5,0,0,0-6.82-1.82l-.94.54a.81.81,0,0,0-.29,1.11c1.58,2.74,3.33,8.19,2.5,11.3l0,.11A15.21,15.21,0,0,1,18,31.81l-.45.59L17,31.32a.81.81,0,0,0-.7-.41.77.77,0,0,0-.41.11L9,35a.83.83,0,0,0-.3,1.12L19.27,54.37a.83.83,0,0,0,1.12.3l6.83-3.94a.83.83,0,0,0,.3-1.12l-.77-1.33.72-.11a29.76,29.76,0,0,0,10.28-3.53l7.69-4.43A3.45,3.45,0,0,0,46.7,35.5ZM20.28,52.85,10.53,36,16,32.83,25.7,49.72ZM45.47,37.69a1.84,1.84,0,0,1-.78,1.07l-.06,0h0l-7.69,4.45a28.33,28.33,0,0,1-9.68,3.31l-1.34.28L18.52,34l.83-1.25a16.29,16.29,0,0,0,2.8-5.58c.81-3-.73-8.47-2.08-11.4l-.2-.44.44-.22a3.37,3.37,0,0,1,4.41,1.33c1.05,1.81,2.7,6.32,2.13,8.47a.82.82,0,0,0,.57,1,.84.84,0,0,0,.62-.09l11.39-6.57a1.81,1.81,0,0,1,1.82,3.14l-6.84,3.95a.81.81,0,0,0-.38.49.81.81,0,0,0,.58,1,.79.79,0,0,0,.62-.08l6.83-4a1.91,1.91,0,0,1,2.52.74,1.8,1.8,0,0,1-.66,2.48h0L37.09,31a.81.81,0,0,0-.3,1.11.78.78,0,0,0,.49.38.79.79,0,0,0,.62-.08l4.56-2.63a1.77,1.77,0,0,1,1.37-.18,1.81,1.81,0,0,1,.51,3.28l-.11.07-4.51,2.6A.82.82,0,0,0,40.53,37l2.28-1.32a1.81,1.81,0,0,1,2.66,2Z"/><path class="cls-blanco" d="M14.56,11.85a.82.82,0,0,0,.61.11.85.85,0,0,0,.51-.36.8.8,0,0,0-.22-1.1h0L13,8.88a.82.82,0,0,0-.5-.17h-.13a.81.81,0,0,0-.68.93.81.81,0,0,0,.33.53Z"/><path class="cls-blanco" d="M21.91,8a.8.8,0,0,0,.75-.85l-.18-2.93a.81.81,0,0,0-1.42-.48.79.79,0,0,0-.2.59L21,7.28A.82.82,0,0,0,21.91,8Z"/><path class="cls-blanco" d="M28.3,10.52,30.58,9.2A.79.79,0,0,0,31,8.71a.84.84,0,0,0-.09-.62.81.81,0,0,0-1.11-.3L27.49,9.11a.78.78,0,0,0-.38.49.79.79,0,0,0,.08.62A.82.82,0,0,0,28.3,10.52Z"/><path class="cls-blanco" d="M11.74,19.81a.86.86,0,0,0,.61-.08l2.28-1.32a.82.82,0,0,0,.3-1.11.81.81,0,0,0-1.11-.3l-2.28,1.31a.83.83,0,0,0-.38.5.79.79,0,0,0,.08.62A.83.83,0,0,0,11.74,19.81Z"/></svg>
          <p class="message-tk">Dada la cantidad de empleados que participarán en actividades solidarias, nos gustaría que nos cuentes qué tienes en mente y en los próximos días nos comunicaremos contigo.
          <b-form-textarea
            id="textarea"
            class="message-textarea"
            v-model="comment"
            placeholder="Deja tu comentario"
            rows="3"
            max-rows="4"
          ></b-form-textarea>
          <small class="errorMessage" v-if="customCommentError==true">Por favor, escribenos un mensaje</small></p>
          <b-button variant="loginInput" @click="customSolicitud">Enviar</b-button>
        </div>
        </div>
        </div>
      </b-row>

      <b-row class="welcomerow steps-wrapper m-l-0 loading" v-bind:class="{ active: confirm == true, ' animate': confirm == true && animate == true }">
        <div class="loader-wrapper thakyoumessage">
          <svg version="1.1" id="confirmation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
            viewBox="0 0 384 384" style="enable-background:new 0 0 384 384;" xml:space="preserve">
          <g>
            <g>
              <path class="check" d="M275.312,140.688c-6.24-6.248-16.384-6.248-22.624,0L184,209.368l-28.688-28.68c-6.24-6.248-16.384-6.248-22.624,0
                c-6.248,6.248-6.248,16.376,0,22.624l40,40C175.808,246.44,179.904,248,184,248s8.192-1.56,11.312-4.688l80-80
                C281.56,157.064,281.56,146.936,275.312,140.688z"/>
            </g>
          </g>
          <g>
            <g>
              <path class="circle" d="M368,176c-8.832,0-16,7.168-16,16c0,88.224-71.776,160-160,160S32,280.224,32,192S103.776,32,192,32
                c42.952,0,83.272,16.784,113.544,47.264c6.216,6.28,16.352,6.312,22.624,0.08c6.272-6.224,6.304-16.352,0.08-22.624
                C291.928,20.144,243.536,0,192,0C86.128,0,0,86.128,0,192s86.128,192,192,192s192-86.128,192-192C384,183.168,376.832,176,368,176
                z"/>
            </g>
          </g>
          </svg>
          <p class="message-tk" v-if="customThankyou">Gracias por enviarnos tu solicitud, un integrante de nuestro equipo se comunicará contigo y te ayudará a configurar una membresía acorde a la cantidad de empleados participantes que nos indicaste.</p>
          <p class="message-tk" v-if="!customThankyou">Gracias por enviarnos tu solicitud, un integrante de nuestro equipo se comunicará contigo para concretar la adquisición de tu membresía.</p>

          <b-button variant="loginInput" @click="done">Ir al inicio</b-button>
        </div>
      </b-row>
  </div>
</template>

<script>

import { UserService } from '../services/user.service'

export default {
  name: "Wizard",
  props: {
    msg: String
  },
  components: {
  },
  watch:{
    percentCustomNumber(val){
      /* eslint-disable no-console */
      console.log(val);
      /* eslint-enable no-console */
 
      if(val<0){
          this.percentCustomNumber = this.activeEmployees;
          this.activeEmployeesNumber=this.activeEmployees*this.employees/100;
        return
      }else if (val>100) {
          this.percentCustomNumber = this.activeEmployees;
          this.activeEmployeesNumber=this.activeEmployees*this.employees/100;
        return
      }else{
        this.activeEmployees = val
        this.percentCustomNumber = this.activeEmployees;
        this.activeEmployeesNumber=this.activeEmployees*this.employees/100;
      }

    }
  },
  data() {
    return {
      showComparator:false,
      solicitudflag: false,
      getpdfflag:false,
      customPercent: false,
      employees: "",
      activeEmployees: 0,
      question : 0,
      loading: false,
      confirm: false,
      benefits: [],
      category:false,
      showTable:false,
      price:1,
      selectedPlan: [],
      plans:[],
      percentCustomNumber:'',
      howmany:'',
      selectedcategory: {
        category_id: 9,
        name: "Sol"
      },
      empresa:{},
      listBenefits:[],
      listBenefitsCommunities:[],
      file:[],
      customForm: false,
      animate:false,
      animateCustom:false,
      comment:'',
      activeEmployeesNumber:'',
      activeEmployeesNumberPivot:'',
      errorEmployees:false,
      errorActiveEmployees:false,
      activeEmployeesNumberError:false,
      showsidebar:false,
      customCommentError:false,
      messageError:'',
      customThankyou:false
    };
  },
  directives: {
      numberOnly: {
          bind: function(el) {
              el.handler = function() {
                  el.value = el.value.replace(/\D+/, '')
              }
              el.addEventListener('input', el.handler)
          },
          unbind: function(el) {
              el.removeEventListener('input', el.handler)
          }
      },
      percentOnly: {
          bind: function(el) {
              el.handler = function() {
                  el.value = el.value.replace(/^(100(\.00?)?|[1-9]?\d(\.\d\d?)?)$/, '')
              }
              el.addEventListener('input', el.handler)
          },
          unbind: function(el) {
              el.removeEventListener('input', el.handler)
          }
      }
  },
  methods: {
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    formatNumber(value) {
        let val = (value/1).toFixed(0).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    setEmployees(){
      this.employees = event.target.value
    },
    activeEmployeesInput: function() {

      this.errorActiveEmployees = false

      if(Number(event.target.value) > Number(this.employees)){
        this.errorActiveEmployees = true
            /* eslint-disable no-console */
            console.log(this.employees);
            console.log(event.target.value);
            /* eslint-enable no-console */

        return false
      }else{
        this.errorActiveEmployees = false
        
        this.activeEmployeesNumber = this.activeEmployeesNumberPivot
        var pivot = this.activeEmployeesNumber*100/this.employees
        this.activeEmployees = pivot//.toFixed(2)
      }

    },
    customPercentInput(){

      if(event.target.value<0){
          event.target.value = 0;
      }else if (event.target.value>100) {
          event.target.value = 100
      }else{
        this.activeEmployees = event.target.value
      }
      this.percentCustomNumber = this.activeEmployees;
      this.activeEmployeesNumber=this.activeEmployees*this.employees/100;

    },
    nextQuestion() {

      if(this.question == 1){
        if(this.employees == ''){
            this.errorEmployee = true
            this.messageError = "Debes indicar la cantidad de empleados."
            return false
        }else{
          this.errorEmployees = false
          this.messageError = ""
        }
      }
      
      if(this.question == 2){

        if(this.activeEmployeesNumber == ''){
            this.activeEmployeesNumberError = true
            this.messageError = "Por favor indica la cantidad de usuarios activos."
            return false
        }else if(Number(this.activeEmployeesNumberPivot) > Number(this.employees)){
            this.activeEmployeesNumberError = true
            this.messageError = "Puedes indicar hasta un máximo de "+this.employees +" empleados."
            return false
        }else if(Number(this.percentCustomNumber) > 100 && this.howmany=="percent"){
            this.activeEmployeesNumberError = true
            this.messageError = "Indica un porcentaje valido."
            return false
        }else{
          this.activeEmployeesNumberError = false
            this.messageError = "";
        }

      }

      if(this.activeEmployeesNumberPivot!=Math.floor(this.activeEmployees*this.employees/100)){
        this.activeEmployeesNumber=Math.floor(this.activeEmployees*this.employees/100);
        this.activeEmployeesNumberPivot=this.activeEmployeesNumber;
      }

      this.question++
      if (this.question == 3){
        this.loading = true
        var emp = this.activeEmployeesNumber;//Math.floor(this.activeEmployees * this.employees/100);
        UserService.saveEmployees(this.employees,emp).then(
        result => {

            /* eslint-disable no-console */
            console.log(result);
            /* eslint-enable no-console */

            if(result.selectedCategory.name != 'Otro'){
              if(emp>2500){
                this.selectPlan(6)
              }else{
                this.benefits = result.plansRow
                this.showTable = true;
                this.plans = result.plans
                this.category = result.selectedCategory
                this.loading = false
              }
            }else{
              this.customForm = true
              setTimeout(()=>{
                this.animateCustom = true
              },300)
              this.loading = false
            }
        }
      );
      }
    },
    backQuestion(){
      if(this.showComparator == true){
        this.showComparator = false
        return true
      }
      this.question--
      this.messageError = ""
      if(this.question==3 && this.activeEmployeesNumber>2500){
        this.question--
      }
      this.showComparator = false
      if (this.question<3){
            this.showTable = false
      }
      if (this.customForm==true){
            this.customForm = false
            this.animateCustom = false
      }
    },
    selectPlan(id){
      /* eslint-disable no-console */
      console.log(this.price);
      /* eslint-enable no-console */
      this.loading = true
      this.showTable = false;
      UserService.selectPlan(id,this.price).then(
      result => {

          /* eslint-disable no-console */
          console.log(result);
          /* eslint-enable no-console */

          if(result && result.status == "success"){
            this.question++;
            this.showTable = true;
            this.loading = false;
            this.selectedPlan = result.selectedPlan;
            this.selectedcategory = result.selectedCategory;
            this.empresa = result.empresa;
            this.listBenefits = result.plansRow || [];
            this.listBenefitsCommunities = result.categoryRow || [];
            this.file = result.files
          }

      }
    );
    },
    customSolicitud(){

      if(this.comment == ""){
        this.customCommentError = true;
        return false;
      }
      this.customCommentError = false;
      this.loading = true;
      this.showTable = false;
       UserService.confirmCustom(this.comment).then(
          result => {

              /* eslint-disable no-console */
              console.log(result);
              /* eslint-enable no-console */

              if(result.status == "success"){
                this.customThankyou=true;
                this.question++;
                this.showTable = false;
                this.loading = false;
                this.confirm = true;

                setTimeout(()=>{
                  this.animate = true
                },300)

              }

          }
       )
    },
    solicitud(){
      if(this.loading==true) return false;
      this.loading = true;
      this.showTable = false;
      this.solicitudflag = true;
      var plan = this.empresa.plan_id;
      var period = this.price;
      var category = this.empresa.category_id;
      UserService.solicitud(plan,period,category).then(
      result => {

          /* eslint-disable no-console */
          console.log(result);
          /* eslint-enable no-console */

          this.solicitudflag = false;
          if(result.status == "success"){
            this.question++
            this.showTable = false;
            this.loading = false;
            this.confirm = true;

            setTimeout(()=>{
              this.animate = true
            },300)

          }

      }
    );
    },
    getFile(){
      if(this.getpdfflag==true) return false;
      this.getpdfflag = true;
      var url = "";
      //var url = 'http://memberships-fhtn.s3.amazonaws.com/plans/manual-de-marca.pdf'
      //var url = 'http://memberships-fhtn.s3.amazonaws.com/plans/'+this.file.name
      //
      UserService.getFile().then(
        result => {
            this.getpdfflag = false;
            /* eslint-disable no-console */
            console.log(result);
            /* eslint-enable no-console */
          if(result.status == "success"){
            url = 'https://membresias-api.fundacionhtn.org'+result.data.path; 
            /* eslint-disable no-console */
            console.log(url);
            /* eslint-enable no-console */
            //window.open(url, "_blank");
            window.location.href = url;
          }
        }
      );
    },
    done(){
      this.showComparator=false
      this.customThankyou=false
      this.customPercent= false
      this.employees= ""
      this.activeEmployees= 0
      this.question = 0
      this.loading= false
      this.confirm= false
      this.benefits= []
      this.category=false
      this.showTable=false
      this.price=1
      this.selectedPlan= []
      this.plans=[]
      this.howmany=''
      this.selectedcategory= {
        category_id: 9,
        name: "Sol"
      }
      this.empresa={}
      this.listBenefits=[]
      this.listBenefitsCommunities=[]
      this.file=[]
      this.customForm=false
      this.animate=false
      this.animateCustom=false
      this.comment=''
      this.activeEmployeesNumber=''
      this.activeEmployeesNumberPivot=''
      this.errorEmployees=false
      this.percentCustomNumber=''
      this.errorActiveEmployees=false
      this.activeEmployeesNumberError=false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.itemb{
  position:relative;
  display: flex;
  max-height: 100px;
  margin-bottom: 30px
}
.itemb b {
    font-weight: 600;
    color: #666063;
}
.itemBenefits .itemb .iconben img {
    position: relative;
    right: 0;
    height: 100%;
    width: auto;
    top: 0;
    transform: translateY(0%);
}
.benefitsitem{
    display: block;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    position: absolute;
    padding-right: 10px
}
.iconben {
  float: left;
  margin-right: 30px;
  width: auto;
  max-width:100px
}
.benefitsitem h5{
  font-size: 1.1rem;
  margin-bottom: 3px;
  font-weight: 600;
  color: rgb(102, 96, 99);
}.benefitsitem h5
.itemBenefits.list {
    padding: 0px 0px 25px;
    border: rgba(223, 139, 56, 0) solid 1px;
}
.itemBenefits.planlist.list {
    padding: 0px 0px 0px;
    border: rgba(32, 126, 121, 0) solid 1px;
}
.benefitsTitle {
    color: #fff;
    font-weight: 600;
    font-size: 20px;
    width: 100%;
    padding: 15px;
    text-align: center;
    background: rgb(223, 139, 56);
    border-radius: 15px;
    margin-bottom: 30px
}
.container-benefit{
    float: left;
    display: block;
    height: 100px;
    border: 1px solid rgb(223, 139, 56);
    margin-bottom: 20px;
    position: relative;
    padding: 10px 20px;
    border-radius: 15px;
    width: 100%;
}
.benefitsitem p{
  margin-bottom: 0
}
.planlist .container-benefit{
  border: 1px solid #00A9C5;
} 
.planlist .benefitsTitle {
    background: #00A9C5;
}
.custom-control-input {
  z-index: 1 !important;
  opacity: 1 !important;
}
input[type='radio']:after {
  width: 20px;
  height: 20px;
  border-radius: 15px;
    top: 0px;
    left: -2px;
  position: relative;
  background-color: #d1d3d1;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
}

input[type='radio']:checked:after, input[type='radio'].selected:after {
  width: 20px;
  height: 20px;
  border-radius: 15px;
  top: 0px;
  left: -2px;
  position: relative;
  background-color: #f9a62e;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid white;
  z-index: 1000;
}

@media screen and (max-width: 480px){
  .iconben {
      float: ;
      margin-right: 15px;
      display: none
  }
  .benefitsitem h5 {
    font-size: 16px;
  }
  .container-benefit {
      float: left;
      display: block;
      height: auto;
      border: 1px solid rgb(223, 139, 56);
      margin-bottom: 20px;
      position: relative;
      padding: 10px 20px;
      border-radius: 15px;
      width: 100%;
  }
  .benefitsitem {
      display: block;
      top: unset;
      -webkit-transform: unset;
      transform: unset;
      position: relative;
      padding-right: 10px;
  }
  .itemb {
      position: relative;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      max-height: unset;
      margin-bottom: 5px;
  }
  .benefitsTitle {
      color: #fff;
      font-weight: 600;
      font-size: 17px;
      width: 100%;
      padding: 15px 25px;
      text-align: center;
      background: rgb(223, 139, 56);
      border-radius: 15px;
      margin-bottom: 30px;
  }
}

.ditem {
    border: 1px solid #37b2ce;
    border-radius: 15px;
    width: calc( 20% - 25px);
    text-align: center;
    transition: 300ms all ease-in-out
}
.ditem2:hover {
    transform: translateY(-1px);
}
.dtitle {
    padding: 15px 0;
    background: #37b2ce;
    color: #fff;
    font-weight: 500;
    border-radius: 13px 13px 0 0;
    font-size: 120%;
}
.ditemcontainer {
    padding: 20px 10px;
}
.ditemcontainer p{
  margin-bottom:5px
}
.ditemcontainer p small{
  font-size: 75%
}
.ditemcontainer h2{
  color:#24515b;
}
.ditemcontainer b{
  color: #24515b;
}
.changeplansview{
  width:100%;
  padding: 50px 10px 0px;
  text-align: center;
  font-size: 80%
}
.changeplansview p{
  
}
@media screen and (max-width: 1200px){
  .ditemcontainer h2{
    font-size: 25px;
  }
}
.noscroll{
  overflow:visible !important
}
.content-container.noscroll{
  overflow: hidden !important
}
@media screen and (max-width: 992px){
  .pricestable {
      display: block;
  }
  .plansstep .designs-holder.pricestable.noscroll{
    display: block !important
  }
  .ditem {
      border: 1px solid #37b2ce;
      border-radius: 15px;
      width: calc( 100%/3 - 20px);
      text-align: center;
      position: relative;
      float: left;
      margin: 0px 10px 20px 
  }
  .ditem:nth-child(4){
    margin-left: calc(100%/6)
  }
  .ditem:nth-child(5){
    margin-right: calc(100%/6)
  }
}

@media screen and (max-width: 640px){
  .ditem {
    width: calc( 100%);
    margin: 0px 0px 20px
  }
  .plansstep .designs-holder.pricestable.noscroll{
    overflow-y: visible !important;
    min-height: unset;
    height: unset;
  }
  .ditemcontainer p {
    margin-bottom: 5px;
    font-size: 20px;
  }
  .row.welcomerow.steps-wrapper.m-l-0.q3.active{
    overflow-y: auto
  }
  .ditem:nth-child(4) {
      margin-left: unset;
  }
  .ditem:nth-child(5) {
      margin-right: unset;
  }
}
.changeplansview p {
    background: #3b3e40;
    color: #fff !important;
    padding: 10px 25px;
}
.changeplansview p:hover {
    opacity: 0.7;
    color: #fff !important;
}
.option input.texts-holder:focus {
    border-color: #f9a62e;
}
@media screen and (max-width: 1366px) and (min-width: 768px){
  .itemBenefits .itemb .iconben img {
      position: relative;
      right: 0;
      height: 100px;
      width: 100px;
      top: 0;
      transform: translateY(0%);
  }
}
</style>
